// extracted by mini-css-extract-plugin
export default {"cta":"oF-z","disabled":"pF-z"};